import React, { useState } from "react";
import SEO from "../components/SEO";
import "../styles/Careers.css";
import { useScrollReveal } from "../hooks/useScrollReveal";

const roles = [
  {
    title: "Frontend Developer",
    details:
      "Build responsive product interfaces using modern React architecture and reusable UI systems.",
  },
  {
    title: "Backend Developer",
    details:
      "Design secure APIs, data models, and integration pipelines for scalable mobile products.",
  },
  {
    title: "UI/UX Designer",
    details:
      "Create product flows, interaction systems, and interface visuals aligned with user goals.",
  },
  {
    title: "Project Manager",
    details:
      "Drive scope planning, execution timelines, and cross-functional coordination across teams.",
  },
];

const benefits = [
  "Performance-driven learning environment",
  "Ownership in real production products",
  "Cross-functional collaboration",
  "Flexible growth paths",
];

function Careers() {
  const [selectedPosition, setSelectedPosition] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  useScrollReveal();

  const openApplyDialog = (position) => {
    setSelectedPosition(position);
    setShowDialog(true);
  };

  const closeDialog = () => {
    setShowDialog(false);
    setSelectedPosition("");
  };

  return (
    <div className="careers">
      <SEO title="Careers" description="Join MacroMatrix — open roles in mobile development, game design, LiveOps, and engineering. Build products used by millions." path="/careers" />
      <section className="careers-header">
        <h1>Careers at MacroMatrix</h1>
        <p>
          Join a focused team building high-impact mobile products and games for
          global users.
        </p>
      </section>

      <section className="careers-content reveal">
        {roles.map((role) => (
          <article
            key={role.title}
            className="position-card"
            onClick={() => openApplyDialog(role.title)}
          >
            <h2>{role.title}</h2>
            <p>{role.details}</p>
            <button
              className="apply-button"
              onClick={(e) => {
                e.stopPropagation();
                openApplyDialog(role.title);
              }}
            >
              Apply Now
            </button>
          </article>
        ))}
      </section>

      <section className="careers-benefits reveal">
        <h3>Why Work With Us</h3>
        <div className="benefit-list">
          {benefits.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {showDialog && (
        <div className="dialog-overlay" onClick={closeDialog}>
          <div className="dialog-box" onClick={(e) => e.stopPropagation()}>
            <h3>Apply for {selectedPosition}</h3>
            <p>
              Send your resume and portfolio to
              <a href="mailto:careers@macromatrix.io"> careers@macromatrix.io</a>
              .
            </p>
            <button className="close-button" onClick={closeDialog}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Careers;
